import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { site, images } from '../data/site';
import { counties } from '../data/serviceAreas';
import { services } from '../data/services';
export function Footer() {
  return <footer className="bg-ink text-steel-300" data-id="element-103" data-mp="36pfvm1o1q37v">
      <div className="hatch h-1.5 w-full" aria-hidden="true" data-id="element-104" data-mp="36q94b86kf2sn" />
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-14 md:grid-cols-2 lg:grid-cols-4" data-id="element-105" data-mp="3ueik9th3kwbv">
        <div data-id="element-106" data-mp="38h7nghhhuo4">
          <div className="inline-block rounded-sm bg-white px-4 py-3" data-id="element-107" data-mp="38zbay6h7b62">
            <img src={site.logo} alt={site.logoAlt} className="h-12 w-auto object-contain" data-id="element-108" data-mp="3lec9wggp4cgx" />
          </div>
          <p className="mt-4 text-sm leading-relaxed" data-id="element-109" data-mp="3qblvtm4vm600">
            Full service, licensed and insured builder serving southeast
            Michigan. Repair, update, renovate — inside and outside, all four
            seasons of the year.
          </p>
          <div className="mt-5 flex items-center gap-3" data-id="element-110" data-mp="3l90ntw47myz9">
            <img src={images.bbb} alt="Better Business Bureau" className="h-10 w-auto bg-white p-1" data-id="element-111" data-mp="3lbmtfq7jj4eu" />
            <img src={images.epa} alt="Lead Safe EPA Certified" className="h-10 w-auto bg-white p-1" data-id="element-112" data-mp="3v8rhxwouzbyt" />
          </div>
        </div>

        <div data-id="element-113" data-mp="82ibxqv2w6ds">
          <h2 className="font-display text-lg font-semibold uppercase tracking-wide text-white" data-id="element-114" data-mp="81yvyfozns2e">
            Contact
          </h2>
          <ul className="mt-4 space-y-3 text-sm" data-id="element-115" data-mp="33no2ai97rmt">
            <li data-id="element-116" data-mp="htd4te2ty487">
              <a href={site.estimatePhone.href} className="flex items-start gap-2.5 transition hover:text-white" data-id="element-117" data-mp="hrs75fl7y564">
                <PhoneIcon className="mt-0.5 h-4 w-4 text-safety" aria-hidden="true" data-id="element-118" data-mp="qt8ibpjuybbe" />
                <span data-id="element-119" data-mp="qr5lalkafhx6">
                  <span className="block font-bold text-white" data-id="element-120" data-mp="msg7wsz920dj">
                    {site.estimatePhone.display}
                  </span>
                  <span className="text-xs uppercase tracking-wide" data-id="element-121" data-mp="two25of9174o">
                    Free estimates &amp; plumbing
                  </span>
                </span>
              </a>
            </li>
            <li data-id="element-122" data-mp="13rpsgnl9gf8u">
              <a href={site.emailHref} className="flex items-start gap-2.5 break-all transition hover:text-white" data-id="element-123" data-mp="13r7mv0cpkoo9">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-safety" aria-hidden="true" data-id="element-124" data-mp="1ckkpiu0kr4nj" />
                {site.email}
              </a>
            </li>
            <li className="flex items-start gap-2.5" data-id="element-125" data-mp="1mjsc87t78bnb">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-safety" aria-hidden="true" data-id="element-126" data-mp="1ml3chxnfr19o" />
              <span data-id="element-127" data-mp="1rhk5b55ky3t3">
                {site.address.company}
                <br data-id="element-128" data-mp="3obevfn6un298" />
                {site.address.line1}
                <br data-id="element-129" data-mp="3oczot9hfgf5i" />
                {site.address.city}, {site.address.state} {site.address.zip}
              </span>
            </li>
          </ul>
        </div>

        <div data-id="element-130" data-mp="2ag5firxejeh6">
          <h2 className="font-display text-lg font-semibold uppercase tracking-wide text-white" data-id="element-131" data-mp="2afx1uxtgg54x">
            Popular Services
          </h2>
          <ul className="mt-4 grid gap-2 text-sm" data-id="element-132" data-mp="25mkh4yrwcihg">
            {services.slice(0, 9).map(s => <li key={s.slug} data-id="element-133" data-mp="1wnp8lg1dqwaz">
                <Link to={`/services/${s.slug}`} className="transition hover:text-safety" data-id="element-134" data-mp="1woi7juu3khik">
                  {s.name}
                </Link>
              </li>)}
            <li data-id="element-135" data-mp="2pcw6cct0fhv6">
              <Link to="/services" className="font-semibold text-safety" data-id="element-136" data-mp="2pa9z6ea174dh">
                View all services →
              </Link>
            </li>
          </ul>
        </div>

        <div data-id="element-137" data-mp="2fdf1typhva0s">
          <h2 className="font-display text-lg font-semibold uppercase tracking-wide text-white" data-id="element-138" data-mp="2fdykxiqvs4ge">
            Service Area
          </h2>
          <p className="mt-4 text-sm leading-relaxed" data-id="element-139" data-mp="13zb8muqqdpws">
            {counties.join(', ')} Counties, Michigan.
          </p>
          <Link to="/service-area" className="mt-3 inline-block text-sm font-semibold text-safety hover:underline" data-id="element-140" data-mp="2rvhenjmv035y">
            See every city we cover →
          </Link>

          <h2 className="mt-8 font-display text-lg font-semibold uppercase tracking-wide text-white" data-id="element-141" data-mp="2iw46cuah1kmt">
            Find Us
          </h2>
          <ul className="mt-3 space-y-2 text-sm" data-id="element-142" data-mp="2ns1lixa00ky0">
            <li data-id="element-143" data-mp="3bjgrd00zhke0">
              <a href={site.social.facebook} target="_blank" rel="noreferrer" className="transition hover:text-safety" data-id="element-144" data-mp="3bl1o8wartff1">
                Facebook
              </a>
            </li>
            <li data-id="element-145" data-mp="36kdmbfl07e61">
              <a href={site.social.houzz} target="_blank" rel="noreferrer" className="transition hover:text-safety" data-id="element-146" data-mp="36jufatww6a6s">
                Houzz profile
              </a>
            </li>
            <li data-id="element-147" data-mp="1v3440wdm2s6b">
              <a href={site.social.bbb} target="_blank" rel="noreferrer" className="transition hover:text-safety" data-id="element-148" data-mp="1nlpgcjo7apme">
                BBB profile
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-149" data-mp="1rnjccengb5g8">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-6 text-xs sm:flex-row sm:items-center sm:justify-between" data-id="element-150" data-mp="1rougwgoq0h8e">
          <p data-id="element-151" data-mp="13vvradcveolv">
            © {new Date().getFullYear()} Total Home Improvement. All rights
            reserved.
          </p>
          <div className="flex gap-5" data-id="element-152" data-mp="1dni3od0y2tq7">
            <Link to="/privacy" className="hover:text-white" data-id="element-153" data-mp="1dojp9bfl6ym6">
              Privacy Policy
            </Link>
            <Link to="/contact" className="hover:text-white" data-id="element-154" data-mp="18viad3fdqz2l">
              Request an Estimate
            </Link>
          </div>
        </div>
      </div>
      <div className="h-16 lg:hidden" aria-hidden="true" data-id="element-155" data-mp="g8xg9v7is8vc" />
    </footer>;
}